<div class="email-body">
  <table style="width: 100%; max-width: 800px; margin: 0 auto;">
    <thead>
    <tr>
      <td colspan="2">
        <img [src]="logoSrc" alt="KKK Logó" height="50" style="margin-right: 14px;"/>
        Kaposvári Keresztény Közösség
      </td>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td colspan="2">
        <div [innerHTML]="htmlText"></div>
      </td>
    </tr>
    </tbody>
    <tfoot>
    <tr>
      <td>
        A hírlevélről való leiratkozáshoz jelentkezz be a <a [href]="fe">honlapon</a>, és módosítsd a beállításaidat.
        Ha ezt a levelet nem hírlevélként kaptad, az üzenet szerzőjének tudod jelezni leiratkozási szándékodat.
      </td>
      <td>
        <img src="/assets/logo-white-wide-2.png" alt="logo" style="min-width:100px;max-width:200px" />
      </td>
    </tr>
    </tfoot>
  </table>
</div>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/email/email-preview/email-preview.component.html